import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';
import PageLoading from '../../common/components/elements/PageLoading';
import { getModification, resetModification } from '../../features/afterSale/afterSaleActions';
import FileUpload from '../../common/components/inputs/FileUpload';
import { apiAfterSaleOptionalDocumentMethodManualUpload, apiDownloadAfterSaleOptionalDocument } from '../../services/axios-client/axeCommons';
import { generalAlertError, generalAlertSuccessToast } from '../../common/utils/alerts';
import managementAxe from '../../services/axios-client/managementServisAxeClient';
// import { useTourContext } from '../../context/useTourContext';
import ErrorComponent from '../../common/components/ErrorComponent';
import AfterSaleToSignDocumentComponent from '../../common/components/redesignComponents/Cards/AfterSaleToSignDocumentComponent';
import { QuoteInfoContainerAfterSale, WaitingForPaymentQuoteInfoAfterSale } from '../../common/components/redesignComponents/Purchase/PaymentStatusAfterSale.styles';
import AfterSaleDocumentComponent from '../../common/components/redesignComponents/Cards/AfterSaleDocumentComponent';
import { after_sale_purchase_statues } from '../../common/constants';
// import { joyrideOptions } from '../../common/utils/joyrideUtils';
// import { handleCallbackModification } from '../../common/utils/joyrideCallbacks';
// import { modificationSteps } from '../../common/utils/joyrideSteps';

export function ModificationPage() {
  const navigate = useNavigate();
  const { modificationId } = useParams();

  const state = useSelector((store) => store.afterSale.modification_page);
  const { loading, modification, error } = state;

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('singleModification') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('singleModification')]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('singleModification');
  //   setState({ run: true, tourActive: true });
  // };

  useEffect(() => {
    getModification(modificationId);
    return () => {
      resetModification();
    };
  }, []);

  const downloadDocument = async (modificationRequestDocumentId) => {
    const response = await managementAxe.get(`/broker/after-sale/modification/documents/${modificationRequestDocumentId}/download`);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };
  const downloadOptionalDocument = async (documentId) => {
    const response = await apiDownloadAfterSaleOptionalDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const showAfterSaleUploadedDocuments = () => {
    const docs = [
      ...modification.after_sale_optional_documents,
    ];

    return (
      <>
        <div className="ps-3 mt-3">
          {docs.length === 0 && (
            <p>Nessun documento caricato.</p>
          )}

          {docs.map((doc) => (
            <AfterSaleToSignDocumentComponent key={doc.id} document={doc} downloadDocument={downloadOptionalDocument} />
          ))}
        </div>

      </>
    );
  };

  const uploadSignedOptionalDocument = async (documentId, file) => {
    const uploadedFile = file[0];
    const reader = new FileReader();
    reader.readAsDataURL(uploadedFile);
    if (uploadedFile.type !== 'application/pdf') {
      generalAlertError('Formato di file errato. Il file deve essere in .pdf');
      return;
    }
    reader.onload = () => {
      apiAfterSaleOptionalDocumentMethodManualUpload(documentId, {
        document: reader.result.replace('data:application/pdf;base64,', ''),
      }).then(() => {
        getModification(modificationId);
        generalAlertSuccessToast('File caricato');
      });
    };
  };

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  if (modification && modification.status !== 5) {
    navigate(`/after-sale/purchase/modification/${modification.id}`);
  }

  return (
    <>
      {/* <Joyride
        steps={modificationSteps}
        continuous
        showBeacon={showBeacon}
        locale={{
          back: 'Indietro',
          close: 'Chiudi',
          last: 'Fine',
          next: 'Prossima',
          open: 'Apri il modale',
          restart: 'Riavvia il tour ',
          skip: 'Salta',
        }}
        styles={{
          options: joyrideOptions,
          buttonNext: {
            backgroundColor: '#00a651',
            outline: 'none',
          },
          buttonBack: {
            color: '#00a651',
            outline: 'none',
          },
          beaconInner: {
            backgroundColor: '#00a651',
          },
          beaconOuter: {
            borderColor: '#00a651',
            backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
          },
          buttonSkip: {
            outline: 'none',
          },
          buttonClose: {
            outline: 'none',
          },
        }}
        run={run}
        callback={(data) => handleCallbackModification(data, modificationSteps, setState)}
        showSkipButton
        showProgress
      /> */}
      <div className="d-flex gap-2">
        <div className="btn btn-success btn-sm text-white px-4 mb-4" onClick={() => navigate('/modifications')}>Torna indietro</div>
        {/* {localStorage.getItem('singleModification') === 'done' && (
          <div style={{ cursor: 'pointer' }} onClick={() => fireNewQuoteTour()}>
            <button className="btn btn-success btn-sm text-white px-4 mb-4">Tutorial</button>
          </div>
        )} */}
      </div>
      <div className="row">
        <div className="col-12 col-md-6">
          <WaitingForPaymentQuoteInfoAfterSale>
            <QuoteInfoContainerAfterSale>
              <h3 className="ps-3">
                <strong>
                  Modifica #
                </strong>
                {modification.id}
              </h3>
              <div className="single-modification-one ps-3 mb-4 mt-0">
                {modification.quotation.insurance_request.customer && (
                  <div>
                    <p className="my-1">
                      <strong> Cliente:</strong>
                      {' '}
                      <span>
                        {modification.quotation.insurance_request.customer.gender !== 'G' ? `${modification.quotation.insurance_request.customer.name} ${modification.quotation.insurance_request.customer.surname}` : modification.quotation.insurance_request.customer.business_name}
                      </span>
                    </p>
                    <p className="my-1">
                      <strong> Stato:</strong>
                      {' '}
                      <div className="badge bg-success">{after_sale_purchase_statues.find((status) => status.id === modification.status)?.name}</div>

                    </p>
                  </div>
                )}
                {modification.quotation.insurance_request.product
                  && (
                    <div>
                      <p className="my-1">
                        <strong> Prodotto:</strong>
                        {' '}
                        <span>
                          {modification.quotation.insurance_request.product.name}
                        </span>
                      </p>
                    </div>

                  )}
                {modification.quotation.company
                  && (
                    <div>
                      <p className="my-1">
                        <strong>  Compagnia:</strong>
                        {' '}
                        <span>
                          {modification.quotation.company.name}
                        </span>
                      </p>
                    </div>

                  )}
                {modification.quotation.insurance_request.vehicle
                  && (
                    <div>
                      <p className="my-1">
                        <strong> Targa:</strong>
                        {' '}
                        <span>
                          {modification.quotation.insurance_request.vehicle.vehicle_plate}

                        </span>
                      </p>
                    </div>
                  )}

                <div>
                  <p className="my-1">
                    <strong>
                      Creato:
                    </strong>
                    {' '}
                    <span>
                      {new Date(modification.created_at).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                    </span>
                  </p>
                </div>
                <div>
                  <p className="my-1">
                    <b>Note:</b>
                  </p>
                  <p className="m-0">
                    {modification.note}
                  </p>
                </div>
              </div>
            </QuoteInfoContainerAfterSale>
          </WaitingForPaymentQuoteInfoAfterSale>
        </div>
        <div className="col-12 col-md-6 mt-3 mt-md-0">
          <WaitingForPaymentQuoteInfoAfterSale>
            <QuoteInfoContainerAfterSale>
              <div className="single-modification-two">
                <h3 className="ps-3">
                  <strong>
                    Documenti
                  </strong>
                </h3>
                <div className="ps-3 mt-3">
                  {modification.documents.length !== 0
                    ? (
                      modification.documents.map((document) => (
                        <AfterSaleDocumentComponent key={document.id} document={document} downloadDocument={downloadDocument} />
                      ))
                    ) : <p>Nessun Documento Trovato</p>}
                </div>
              </div>
            </QuoteInfoContainerAfterSale>
          </WaitingForPaymentQuoteInfoAfterSale>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12 col-xl-6">
          <WaitingForPaymentQuoteInfoAfterSale>
            <QuoteInfoContainerAfterSale>
              <h3 className="ps-3">
                <strong>
                  Documenti Da Firmare
                </strong>
              </h3>
              <div>
                {showAfterSaleUploadedDocuments()}
              </div>
              <div className="col-12 mt-3 mt-xl-2 d-flex single-modification-three">
                <div className="col-6 mt-3 mt-xl-0">
                  <div className="card ps-3">
                    <div className="card-body px-0">
                      {modification.after_sale_optional_documents.filter((document) => document.signable_document === 1 && document.is_uploaded_valid === 1 && ((document.is_signed_valid === 0 && document.signed_document_filename !== null) || (document.is_signed_valid === null && document.signed_document_filename === null))).map((file) => (
                        <div className="mb-3">
                          <FileUpload
                            key={file.id}
                            multiple={false}
                            label={`CARICA ${file.optional_document_name.toUpperCase()}`}
                            handleFile={(f) => uploadSignedOptionalDocument(file.id, f)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </QuoteInfoContainerAfterSale>
          </WaitingForPaymentQuoteInfoAfterSale>
        </div>
      </div>

    </>
  );
}
